/* eslint-disable no-nested-ternary */
/**
 *
 * @param {string} objectId
 * @param {object} buildingsLayer
 * @param {object} view
 */
export default function goToGoogleMaps(geometry) {
  console.log(geometry);
  const { latitude, longitude } = geometry.centroid;
  const googleMapUrl = `https://www.google.com/maps/place/${latitude},${longitude}`;
  window.open(googleMapUrl, "_blank");
}
